// components/HamburgerMenu.jsx
import React, { useState } from 'react';

function HamburgerMenu({ navigate, handleNavigateAndScroll, goToExternalUrl }) {
  const [open, setOpen] = useState(false);
  const toggleMenu = () => setOpen(o => !o);

  return (
    <>
      {/* Hamburger Button */}
      <button
        onClick={toggleMenu}
        className="p-2 focus:outline-none text-black"
        aria-label={open ? 'Close menu' : 'Open menu'}
      >
        <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16 M4 12h16 M4 18h16" />
        </svg>
      </button>

      {/* Dropdown Panel spans full header width */}
      {open && (
        <div className="absolute top-full left-0 right-0 bg-white shadow-md z-50">
          <div className="flex flex-col p-4 space-y-4">
            {/* Navigation Links */}
            <button
              className="text-left text-lg font-medium text-black"
              onClick={() => { handleNavigateAndScroll('/', null); setOpen(false); }}
            >
              Home
            </button>
            <button
              className="text-left text-lg font-medium text-black"
              onClick={() => { handleNavigateAndScroll('/meet-us', 'aboutSection'); setOpen(false); }}
            >
              About Us
            </button>
            <button
              className="text-left text-lg font-medium text-black"
              onClick={() => { handleNavigateAndScroll('/services', 'servicesSection'); setOpen(false); }}
            >
              Services
            </button>
            <button
              className="text-left text-lg font-medium text-black"
              onClick={() => { handleNavigateAndScroll('/patient-center', 'servicesSection'); setOpen(false); }}
            >
              Patient Center
            </button>
            <button
              className="text-left text-lg font-medium text-black"
              onClick={() => { handleNavigateAndScroll('/contact-us', 'contactSection'); setOpen(false); }}
            >
              Contact Us
            </button>

            <hr className="border-gray-200" />

            {/* Action Buttons (full-width) */}
            <button
              className="w-full border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-orange hover:bg-custom-darkOrange text-white"
              onClick={() => { goToExternalUrl('https://healow.com/apps/practice/central-il-pediatric-assoc-llc-bloomington-il-10568?v=2&locale=en'); setOpen(false); }}
            >
              Schedule Appointment
            </button>
            <button
              className="w-full border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-green hover:bg-custom-darkGreen text-white"
              onClick={() => { goToExternalUrl('https://www.healowpay.com/HealowPay/jsp/healow/login.jsp'); setOpen(false); }}
            >
              Bill Pay
            </button>
            <button
              className="w-full border-2 border-black rounded-full px-4 py-2 font-semibold drop-shadow-md bg-custom-blue hover:bg-[#0F1B30] text-white"
              onClick={() => { goToExternalUrl('https://mycw65.ecwcloud.com/portal8399/jsp/100mp/login_otp.jsp'); setOpen(false); }}
            >
              Patient Portal
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default HamburgerMenu;